import { render } from "./ProductLink.vue?vue&type=template&id=95a6a87e"
import script from "./ProductLink.vue?vue&type=script&lang=js"
export * from "./ProductLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__